import { MenuItem } from "@mui/material";
import { useState } from "react";
import { showToast } from "@/modules/common/utils";
import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { useExtendProposal } from "@/modules/property-tracks/hooks/rental-financial-proposal/extend-proposal.hook";
import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";

const PROPOSAL_EXTENSION_DAYS = 14;

interface ExtendProposalProps {
  uid: string;
  rootVersion: number;
  minorVersion: number;
}

export default function ExtendFinancialProposal({
  uid,
  rootVersion,
  minorVersion,
}: ExtendProposalProps) {
  const [open, setOpen] = useState(false);
  const mutation = useExtendProposal();

  const handleExtend = () => {
    mutation.mutate(
      { uid },
      {
        onSuccess: () => {
          showToast({
            type: ToastType.SUCCESS,
            message: `Proposal extended successfully for ${PROPOSAL_EXTENSION_DAYS} days`,
            toastId: TOAST_IDS.EXTEND_FINANCIAL_PROPOSAL_SUCCESS,
          });
          setOpen(false);
        },
        onError: (error) => {
          showToast({
            type: ToastType.ERROR,
            message:
              error?.response?.data?.message ||
              "Unexpected error occurred. Please try again.",
            toastId: TOAST_IDS.EXTEND_FINANCIAL_PROPOSAL_ERROR,
          });
        },
      }
    );
  };

  const { readonly } = useReadonlyContext();

  const versionString = `${rootVersion}.${minorVersion}`;

  return (
    <>
      <MenuItem
        sx={(t) => t.nawy.typography.english.variants.body.md.regular}
        onClick={() => setOpen(true)}
        disabled={readonly}
      >
        Extend
      </MenuItem>

      <ConfirmationModal
        open={open}
        setOpen={setOpen}
        title="Extend Proposal"
        body={`This action will extend proposal version ${versionString} for ${PROPOSAL_EXTENSION_DAYS} days. Continue?`}
        onConfirmHandler={handleExtend}
        isLoading={mutation.isPending}
      />
    </>
  );
}
